<template>
  <div class="hardware-manage">
    <div class="buttons">
      <el-button @click="add" type="primary">添加固件</el-button>
    </div>
    <el-table :data="table">
      <el-table-column label="固件名称" prop="firmwareName"></el-table-column>
      <el-table-column label="固件版本号" prop="firmwareVersion"></el-table-column>
      <el-table-column label="固件大小">
        <template #default="scope">
          {{scope.row.firmwareSize}}MB
        </template>
      </el-table-column>
      <el-table-column label="添加时间" prop="createTime">
        <template #default="scope">
          {{formatTime(scope.row.createTime)}}
        </template>
      </el-table-column>
      <el-table-column label="固件说明" prop="remark"></el-table-column>
      <el-table-column label="操作" width="180">
        <template #default="scope">
          <a @click="edit(scope.row)" style="margin-right: 8px; cursor: pointer;">编辑</a>
          <a @click="remove(scope.row)" style="cursor: pointer;">删除</a>
        </template>
      </el-table-column>
    </el-table>
    <RModal title="添加固件" v-model="visible">
      <template #content>
        <el-form label-width="100px">
          <el-form-item label="固件名称" required>
            <el-input v-model="form.firmwareName" placeholder="请输入固件名称"/>
          </el-form-item>
          <el-form-item label="设备类型" required>
            <el-select v-model="form.deviceType">
              <el-option label="门锁" :value="103"></el-option>
              <el-option label="门铃" :value="104"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="固件版本号" required>
            <el-input v-model="form.firmwareVersion" placeholder="请输入固件版本号"/>
          </el-form-item>
          <el-form-item label="上传固件" required>
            <div @click="selectFile" style="cursor: pointer;">{{form.fileName || '点击上传固件源文件'}}</div>
          </el-form-item>
          <el-form-item label="固件说明">
            <el-input v-model="form.remark" placeholder="请输入固件更新内容"/>
          </el-form-item>
        </el-form>
        <div>
          <el-button @click="confirm" type="primary">确定</el-button>
          <el-button @click="cancel">取消</el-button>
        </div>
      </template>
    </RModal>
  </div>
</template>

<script>
import RModal from "@/components/common/RModal";
import { ElMessage, ElMessageBox } from 'element-plus'
import {formatTime, selectFile, upload} from "@/utils/index.js";
const initForm = () => ({
  deviceType: 103,
  firmwareName: "", // 固件名称
  firmwareVersion: "", // 固件版本号
  remark: "", // 固件说明
  url: "", // 固件地址
  fileName: "", // 文件名称
});
export default{
  name: "HardwareManage",
  components: {
    RModal,
  },
  data() {
    return {
      visible: false,
      table: [],
      form: initForm(),
    }
  },
  methods: {
    selectFile(){
      selectFile().then(res => {
        const size = res.file.size / 1024 / 1024;
        if(size >= 10){
          return ElMessage.error("文件最大支持10MB");
        }
        upload("/saas/api/web/fileStorage/uploadUpgradeFile", {
          upgradeFile: res.file,
        }).then(({code, data}) => {
          this.form = {
            ...this.form,
            ...data,
            firmwareSize: size,
          };
        })
      })
    },
    formatTime(value){
      return formatTime(value);
    },
    add(){
      this.fileName = "";
      this.form = initForm();
      this.visible = true;
    },
    edit(row){
      this.form = row;
      this.visible = true;
    },
    confirm(){
      this.axios.post('/api/web/upgradeFirmware/saveOrUpdate', this.form).then(res => {
        if(res.data.code == 200){
          ElMessage({
            type: "success",
            message: "操作成功",
          });
          this.visible = false;
          this.getList();
        }
      })
    },
    cancel(){
      this.visible = false;
    },
    remove(row){
      ElMessageBox.confirm("是否确定删除?", "提示").then(() => {
        this.axios.post('/api/web/upgradeFirmware/deleteByIds', [row.id]).then(res => {
          ElMessage.success("操作成功");
          this.getList();
        })
      })
    },
    getList(){
      this.axios.get('/api/web/upgradeFirmware/findPage').then(res => {
        this.table = res.data.data.data;
      })
    },
    getDetail(id){
      this.axios.get(`/api/web/upgradeFirmware/detail?id${id}`).then(res => {
        console.log(res);
      })
    }
  },
  created(){
    this.getList();
  }
};
</script>

<style lang="less">
.hardware-manage{
  .buttons{
    margin-bottom: 8px;
  }
}
</style>